/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getCaptcha, getUserByToken, login} from '../core/_requests'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
      .min(3, 'حداقل 3 کاراکتر مورد تایید میباشد')
      .max(50, 'حداکثر 50 کاراکتر مورد تایید میباشد')
      .required('اجباری میباشد'),
  password: Yup.string()
      .min(3, 'حداقل 3 کاراکتر مورد تایید میباشد')
      .max(50, 'حداکثر 50 کاراکتر مورد تایید میباشد')
      .required('اجباری میباشد'),
  captcha: Yup.string()
      .min(4, 'تصویر امنیتی را به درسی وارد نمایید')
      .max(4, 'تصویر امنیتی را به درسی وارد نمایید')
      .required('تصویر امنیتی اجباری میباشد')
})

const initialValues = {
  email: '',
  password: '',
  captcha: ''
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const [captcha, setCaptcha] = useState("");
  const {saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password, values.captcha)
        saveAuth(auth)
        const {data: user} = await getUserByToken(auth.access_token)
        setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('اطلاعات وارد شده معبتر نمیباشد')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  async function refreshCaptcha() {
    try {
      const {data: captchaData} = await getCaptcha();
      setCaptcha(captchaData);
    } catch {

    }
  }
  useEffect(()=>{
    refreshCaptcha()
  },[])
  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>ورود به پرتال</h1>
      </div>
      {/* begin::Heading */}


      {/* begin::Separator */}
      <div className='separator separator-content my-14'>
        {/*<span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>*/}
      </div>
      {/* end::Separator */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
          <div></div>
        // <div className='mb-10 bg-light-info p-8 rounded'>
        //   <div className='text-info'>
        //     Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
        //     continue.
        //   </div>
        // </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>نام کاربری</label>
        <input
          placeholder='نام کاربری'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='text'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>رمز عبور</label>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      {/*<div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>*/}
      {/*  <div />*/}

      {/*  /!* begin::Link *!/*/}
      {/*  <Link to='/auth/forgot-password' className='link-primary'>*/}
      {/*    بازیابی رمز عبور ?*/}
      {/*  </Link>*/}
      {/*  /!* end::Link *!/*/}
      {/*</div>*/}
      {/* end::Wrapper */}
      {/* begin::Form group */}
      <div className='fv-row mb-10 row'>
        <div className="col-6">
          <label className='form-label fs-6 fw-bold text-dark'>تصویر امنیتی</label>

          <input
              placeholder='تصویر امنیتی '
              {...formik.getFieldProps('captcha')}
              className={clsx(
                  'form-control form-control-lg form-control-solid ',
                  {'is-invalid': formik.touched.captcha && formik.errors.captcha},
                  {
                    'is-valid': formik.touched.captcha && !formik.errors.captcha,
                  }
              )}
              type='text'
              name='captcha'
              autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.captcha}</span>
              </div>
          )}
        </div>

        <div className="col-6 ">
          <label className='form-label fs-6 fw-bold text-dark'>تصویر </label>
          <div className="row">
            <div className="col-8">
              <img src={captcha} className="col-8"/>
            </div>
            <div className="col-4">
              <button onClick={refreshCaptcha} type="button" className="btn btn-light-primary me-3">

                <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-2'/>

              </button>
            </div>

          </div>


        </div>

      </div>
      {/* end::Form group */}
      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>ادامه</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              در حال بارگزاری...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/*<div className='text-gray-500 text-center fw-semibold fs-6'>*/}
      {/*  Not a Member yet?{' '}*/}
      {/*  <Link to='/auth/registration' className='link-primary'>*/}
      {/*    Sign up*/}
      {/*  </Link>*/}
      {/*</div>*/}
    </form>
  )
}
